import { cookieState } from '../reducer/cookieReducer';
import { dialogState } from '../reducer/dialogReducer';
export const initialState = {
    cookieState,
    dialogState,
};
